import styled from 'styled-components';

export const Container = styled.div`
  outline: solid 1px ${({ theme }) => theme.colors.border.light};
  min-height: 100px;
`;

export const Wrapper = styled.div<{ $isFirst: boolean; $isLast: boolean; $isSelected: boolean; $isClickable: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.background};
  border: ${({ $isSelected, theme }) => ($isSelected ? `solid 2px ${theme.colors.primary}` : `none`)};
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  border-bottom-left-radius: ${({ $isFirst, theme }) => ($isFirst ? theme.borderRadius.md : '0')};
  border-bottom-right-radius: ${({ $isLast, theme }) => ($isLast ? theme.borderRadius.md : '0')};
  transition: all 0.2s ease;
  min-width: 0;
  padding: 8px 4px;
  height: 100%;

  /* ホバー状態 */
  &:hover {
    background-color: ${({ $isClickable, theme }) =>
      $isClickable
        ? theme.colors.backgroundSecondary
        : 'transparent'};
  }
`;

export const DayNumber = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.xl};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const DayStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-top: 4px;

  svg {
    &:first-child {
      width: 24px;
      height: 24px;
    }

    &:last-child {
      width: 30px;
      height: 15px;
    }
  }
`;
